<template>
  <div>
    <v-sheet class="pa-3" v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        max-width="100%"
        type="table-tbody"
      />
    </v-sheet>
    <v-data-table
      v-else
      dense
      :headers="headers"
      :items="items"
      :items-per-page="itemsPerPage"
      class="elevation-0 custom-table mt-4"
      hide-default-footer
      v-on="$listeners"
    >
      <template slot="no-data">{{ $t('Default.empty') }}</template>
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'AdminDataTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
      default: 1000,
    },
  },
};
</script>
